module.exports = __webpack_public_path__ + "static/media/classic3.e8b94ddd.jpg";